import { FirebaseApp } from '@firebase/app';
import { Firestore, getFirestore } from '@firebase/firestore';
import { PEECH_FIRESTORE_DATABASE_ID } from './firebase-config';

export function getPeechFirestore(app: FirebaseApp): Firestore {
  return getFirestore(app, PEECH_FIRESTORE_DATABASE_ID);
}
